import copy from './generated/copy.json';
export const words =
  (locale) =>
  (key, values = {}) =>
    (copy[locale]?.[key] ?? copy.ko[key] ?? key).replace(/\{\{(\w+)\}\}/g, (_, name) =>
      String(values[name] ?? ''),
    );
export const recentActivities = (ratings = [], playlists = []) =>
  [
    ...ratings.map((item) => ({
      key: `review-${item.review.id}`,
      kind: item.review.content?.trim() ? 'review' : 'rating',
      date: item.review.updatedAt || item.review.createdAt,
      item,
    })),
    ...playlists.map((item) => ({
      key: `playlist-${item.id}`,
      kind: 'playlist',
      date: item.updatedAt || item.createdAt,
      item,
    })),
  ]
    .sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
    .slice(0, 3);
export const earnedBadges = (collection) =>
  collection?.categories.flatMap((c) => c.badges).filter((b) => b.unlockedAt) ?? [];
export function unwrapCollection(response) {
  const d = response?.data?.data ?? response?.data;
  if (
    !d ||
    !Array.isArray(d.categories) ||
    !Number.isFinite(d.earnedCount) ||
    !Number.isFinite(d.totalCount) ||
    d.categories.some((c) => !Array.isArray(c.badges))
  )
    throw Error('Invalid badge collection');
  return d;
}
export const visibleBadge = (rect, top, bottom) =>
  rect.height > 0 && rect.top >= top && rect.top + Math.min(rect.height, 140) <= bottom;
